import * as React from 'react';
import { Feature, WorkbenchUIConfig, UIConfig, IActionPointInfo } from '@tencent/workbench';
import BaseToolbarFeature from '@framework/workbench/common/feature/base-toolbar-feature';
import { config, TAILOR_PIC_SHAPE } from './config';
import ShapePickMenu, { TopMenuShapeConstant } from '@com-pc/shape-pick-menu';
import { ToolbarType } from '@src/js/constant';
import Style from '@framework/workbench/ui/insert/insert-shape/index.less';
import { wrapIdForBig } from '@src/framework/workbench/util/wrap-id-util';

const SINGLE_SHAPE_ID = '#toolbar-button-shape-menu-item';
const DOUBLE_SHAPE_ID = '#toolbar-button-shape-menu-item-workbench-big';

@Feature()
export class InsertShapeFeature extends BaseToolbarFeature {
    public id = config.id;
    public menuDom;
    public constructor() {
        super();
    }

    public getContent(info: IActionPointInfo) {
        let height = TopMenuShapeConstant.MAX_HEIGHT;
        const toolbarMode = this.getAppService().viewableServiceLayer.toolbarStateManager.getToolbarMode();
        let rectId;
        if (toolbarMode === ToolbarType.SINGLE_TOOLBAR) {
            rectId = SINGLE_SHAPE_ID;
        } else {
            rectId = DOUBLE_SHAPE_ID;
        }
        const recDomList = document.querySelectorAll(rectId) || [];
        if (recDomList.length) {
            const rectDom = recDomList[recDomList.length - 1];
            const rect = rectDom.getBoundingClientRect();
            const { top } = rect;
            const vh = document.body.clientHeight;
            height = vh - top - 74;
        }

        return (
            <div
                ref={(ref) => {
                    this.menuDom = ref;
                }}
                className={`${Style['insert-shape-background']} ${Style['insert-shape-toolbar']}`}
                style={{
                    maxHeight: TopMenuShapeConstant.MAX_HEIGHT,
                    height,
                }}>
                <ShapePickMenu
                    hideMenu={() => {}}
                    isFromDropdown={true}
                    noBackDrop={true}
                    isFromInsertPanel={false}
                    wbPath={info.path}/>
            </div>
        );
    }

    public getPcBtnContent(@UIConfig() config: WorkbenchUIConfig, info: IActionPointInfo) {
        const { name } = config;
        const cropPicker = name === TAILOR_PIC_SHAPE.name || name === wrapIdForBig(TAILOR_PIC_SHAPE.name);
        return (
            <div
                className={`${Style['insert-shape-background']} ${Style['insert-shape-menu']}`}
                style={{
                    height: 'auto',
                }}>
                <ShapePickMenu
                    cropPicker={cropPicker}
                    hideMenu={() => {}}
                    isFromDropdown={true}
                    isFromInsertPanel={true}
                    noBackDrop={true}
                    wbPath={info.path} />
            </div>
        );
    }
}
